import { Canceler } from "axios";
import { EntityApi } from "../../services/ApiPlatform";
import { FinalResponse, ListResponse } from "../../services/ApiPlatform/models";
import { PrimitiveObject } from "../../services/ApiPlatform/types";

export abstract class TimesheetApi extends EntityApi {
    protected static GET_COLLECTION = "/api/timesheets";

    protected static POST_COLLECTION = "/api/timesheets";

    protected static GET_ITEM = "/api/timesheets/{id}";

    protected static PUT_ITEM = "/api/timesheets/{id}";

    protected static PATCH_ITEM = "/api/timesheets/{id}";

    protected static DELETE_ITEM = "/api/timesheets/{id}";

    protected static GET_COLLECTION_STUDENT = "/api/timesheets/get-for-student";

    protected static GET_COLLECTION_VALIDATION =
        "/api/timesheets/get-for-validation";

    protected static POST_VALIDATION_REQUEST = "/api/timesheets/validate";

    protected static POST_REPORT = "/api/timesheets/report";

    public static async getCollectionForStudent<R>(
        page = 1,
        extraParams: PrimitiveObject = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_STUDENT,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }

    public static async getCollectionForValidation<R>(
        page = 1,
        extraParams: PrimitiveObject = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_VALIDATION,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }

    public static async postTimesheetValidation<R, P>(
        entity: P,
        extraParams = {}
    ): Promise<FinalResponse<R | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.POST_VALIDATION_REQUEST,
        };
        return this.postCollection(entity, extraParams);
    }

    public static async postCollectionReport<R, P>(
        entity: P,
        extraParams = {}
    ): Promise<FinalResponse<R | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.POST_REPORT,
        };
        return this.postCollection(entity, extraParams, {
            responseType: "blob",
        });
    }
}
